/**
 * v35
 * added modifiers schema
 *
 */

export const schemaV35 = {
    taxes: 'id, name, value, deleted, [id+deleted], [taxType+deleted]',
    paymentMethods:
        'id, name, type, deleted, enabled, [id+deleted], [enabled+deleted]',
    staff: 'id, authUserId, role, deleted, registerPin, [registerPin+deleted], [id+deleted]',

    items: 'id, name, itemType, categoryId, measurementUnitId, isActive, [id+isActive], nameLower, *searchTokens, updatedAt, [isActive+nameLower]',
    itemVariants:
        'id, name, sku, itemPriceType, itemId, deleted, currentStock, barcode, *barcodes, [id+deleted], [itemId+deleted], [sku+deleted]',

    itemVariantCompositions:
        'id, variantId, deleted, [id+deleted], parentVariantId, [parentVariantId+deleted]',

    categories: 'id, name, deleted, [id+deleted]',
    measurementUnits: 'id, name, deleted, [id+deleted]',

    discounts: 'id, hasRules, deleted, *customerGroupIds, [hasRules+deleted]',

    unsyncedSales:
        'id, orderDate, orderNumber, failed, branchId, [branchId+failed]',

    carts: 'id, name, createdAt, status, syncStatus, cartVersion, createdById, [status+createdById], [status+createdAt]',
    terminals: 'serialNumber',

    pricingGroups: 'id, name, enabled, deleted, [id+deleted]',
    mixpanelEvents: '++id,eventName,properties',
    paymentRestrictions: 'id,type',

    printers:
        'id, name, useAsSalePrinter, useAsDocketPrinter, createdAt, *docketIds',

    dockets: 'id, name, deleted, [id+deleted]',
    modifiers: 'id, name, deleted, [id+deleted+active]',
};
